module.exports = __webpack_public_path__ + "static/img/headImg.7ca6e18.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/user/headImg.png
// module id = 82bX
// module chunks = 1